import { Api } from '../api/Api.js'

export function apiStoreSaleInvoice(body) {
  return Api('post', '/invoice/store_sale_invoice', {body})
}
